export default __webpack_public_path__ + "static/media/logoPS.ae4d41a3.svg";